import { Badge } from "@workanywhere/ui";
import { getTaskDisplayStatus } from "../../agent-updates";
import type { AgentTaskRecord, AgentUpdateSummary } from "../../../../../shared/agent";
import { Metric } from "./ui-bits";
import type { ConnectionState } from "./use-agent-updates";

export function getSessionSummaryMetrics(summary: AgentUpdateSummary): Array<{ label: string; value: string }> {
  const tokenUsage = summary.latestUsage
    ? `${summary.latestUsage.input_tokens.toLocaleString()} / ${summary.latestUsage.output_tokens.toLocaleString()}`
    : "none";

  return [
    { label: "Input / Output", value: tokenUsage },
    { label: "Events", value: summary.total.toLocaleString() },
    { label: "Types", value: Object.keys(summary.counts).length.toString() },
    { label: "Thread", value: summary.currentThreadId ?? "none" },
    { label: "Output", value: summary.latestUsage ? summary.latestUsage.output_tokens.toLocaleString() : "none" },
  ];
}

export function SessionSummary({
  summary,
  connectionState,
  errorMessage,
  selectedTask,
}: {
  summary: AgentUpdateSummary;
  connectionState: ConnectionState;
  errorMessage: string | null;
  selectedTask: AgentTaskRecord | null;
}) {
  const metrics = getSessionSummaryMetrics(summary);

  return (
    <div className="shrink-0 border-b bg-card/40 p-3">
      <div className="flex flex-wrap items-start justify-between gap-3">
        <div className="min-w-0">
          <h2 className="truncate text-sm font-semibold">{selectedTask?.title ?? "Task Summary"}</h2>
          <p className="mt-1 text-xs text-muted-foreground">
            {selectedTask
              ? `${selectedTask.runs.length} ${selectedTask.runs.length === 1 ? "run" : "runs"} · ${getTaskDisplayStatus(selectedTask)}`
              : "Select a task to inspect its timeline"}
          </p>
        </div>
        <Badge variant="outline">{connectionState}</Badge>
      </div>

      <div className="mt-2 grid grid-cols-2 gap-2 sm:grid-cols-5">
        {metrics.map((metric) => (
          <Metric key={metric.label} label={metric.label} value={metric.value} />
        ))}
      </div>

      {errorMessage ? (
        <div className="mt-3 rounded-lg border border-destructive/30 bg-destructive/5 p-3 text-sm text-destructive">
          {errorMessage}
        </div>
      ) : null}
    </div>
  );
}
